import { useEffect } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { AuthProvider } from '../lib/useAuth';
import { trackPageView } from '../lib/analytics';

/** Top-level layout: provides auth context and logs GA4 page views on navigation. */
export function RootLayout() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <AuthProvider>
      {/* Following a link used to leave you at whatever scroll offset you were
          already at, which on a long page drops you into the middle of the next
          one. This puts a new page at the top and still restores your place on
          back and forward. */}
      <ScrollRestoration />
      <Outlet />
    </AuthProvider>
  );
}
